import { AlertTriangle } from 'lucide-react';

/**
 * 加载失败态。
 *
 * 与"空数据"必须明确区分：此前大量 `catch {}` 静默吞掉错误，
 * 界面上直接落到"暂无数据"分支 —— 用户会以为数据丢了。
 * 数据加载失败时改渲染本组件，并提供重试。
 */
export function LoadError({
  message = '加载失败，请检查网络后重试',
  onRetry,
  compact = false,
}: {
  message?: string;
  onRetry?: () => void;
  /** 紧凑模式：用于卡片/侧栏等窄区域 */
  compact?: boolean;
}) {
  return (
    <div className="load-error" style={compact ? { padding: '16px 12px', gap: 6 } : undefined}>
      <AlertTriangle size={compact ? 16 : 22} className="load-error-icon" />
      <span className="load-error-message">{message}</span>
      {onRetry && (
        <button className="load-error-retry" onClick={onRetry}>
          重试
        </button>
      )}
    </div>
  );
}
